// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Byye","title":"Header_title__1hGT7","left":"Header_left__1so33","clinicName":"Header_clinicName__3cOyR"};